import { defineMessage, AudienceFilter } from 'magpie-lib/models';
import * as t from 'ts-schema';

// This is setup in the standard way for now, we can revisit to have more strict audience filtering if needed
export const assistantTopicFilter = AudienceFilter.builder().crossTab().crossPortal().build();
export const assistantPublishMessage = defineMessage({
  type: '@assistant/publish',
  payloadSchema: t.object({
    isAssistantBusy: t.boolean
  })
});